const Tabs = (function () {
  // If hash changes while we're on the page, click the tab corresponding to that hash
  function handleHashChange() {
    $(window).bind('hashchange', () => {
      const hash = window.location.hash.slice(1);
      switchTab(hash);
    });
  }

  // We are using bootstrap tabs, but with custom tab activation logic
  function handleClickedTab() {
    $(document).on('click', '.tabbable:not(.static) .nav-tabs a:not(.disabled)', function (e) {
      e.preventDefault();

      if ($(this).prop('href') == $('.nav-tabs a.active').prop('href')) {
        return;
      }

      switchTab($(this));

      if (history.pushState) {
        history.pushState({}, document.title, this.href);
      }
    });
  }

  /**
   * Fires tabs:beforeSwitch and tabs:afterSwitch
   */
  function switchTab(tab, e) {
    if (typeof tab === 'string') {
      const tabString = encodeURIComponent(tab);
      tab = getTab(tabString);
      // No tab found - due to facebook #_=_ hash.
      if (!tab || tab.length === 0) {
        return;
      }
      window.location.hash = tabString;
    }

    $.event.trigger('tabs:beforeSwitch', tab);
    const top = $(window).scrollTop();
    const href = $(tab).attr('href');
    const tabbable = $(tab).parents('.tabbable').first();

    // Set active tab
    tabbable.find('.nav-tabs a').removeClass('active');
    $(tab).addClass('active');

    // Set active pane
    tabbable.find('div.tab-pane').removeClass('active');

    let newlyActiveTab = $(document.querySelector(`div.tab-pane${href}`));
    if (!newlyActiveTab.length) {
      newlyActiveTab = $(document.querySelector(`div.tab-pane[data-tab=${href}]`));
    }
    newlyActiveTab.addClass('active');

    tabbable.find('li[data-tab-href]').removeClass('active').hide();
    tabbable.find(`li[data-tab-href='${href}']`).addClass('active').show();

    $(newlyActiveTab).focusFirstInput();
    $.event.trigger('tabs:afterSwitch', tab);
    $(window).scrollTop(top);
  }

  function showTabSurrounding(subElement) {
    const id = $(subElement).parents('.tab-pane').prop('id');
    switchTab(id);
  }

  function openTabToCurrentHash() {
    // Set active tab based on URL anchor
    const anchor = window.location.hash;
    const redirectAnchor = $('body').data('anchor');

    if (anchor) {
      switchTab(anchor);
    } else if (redirectAnchor) {
      switchTab(redirectAnchor);
    }
  }

  function getTab(id) {
    // crappy hash passed in after facebook login
    if (id.match(/=/)) {
      return false;
    }

    if (!id.match(/^#/)) {
      id = `#${id}`;
    }

    return $(`.nav-tabs a[href="${id}"]`);
  }

  return {
    init() {
      handleHashChange();
      handleClickedTab();
      openTabToCurrentHash();
    },

    showTabSurrounding,
    switchTab,
  };
})();

$(() => {
  Tabs.init();
});

export default Tabs;
